import { secondary, medium } from '../../../core/GlobalStyles'

export default {
  textTimer:{
    color: secondary,
    fontFamily: 'revalia',
    fontSize: medium
  }
}